import {
  SERVICES_REQUEST_FAIL,
  SERVICES_REQUEST_SUCCESS,
  RESET_SERVICE
} from '../action.types'
import initialState from '../initial.state'

export default function (state = initialState.services, action) {
  switch (action.type) {
    case SERVICES_REQUEST_SUCCESS:
      return { ...action.payload }
    case SERVICES_REQUEST_FAIL:
      return state
    case RESET_SERVICE:
      return initialState.services
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/service/services.reducer.js